// @flow

import _ from "lodash"
import { toastr } from "react-redux-toastr"

let api = "http://localhost:3001/v1";
if (process.env.REACT_APP_API_URL) {
  api = process.env.REACT_APP_API_URL;
}

if (window.location.protocol === "https:" && !api.startsWith("https")) {
  api = api.replace("http", "https");
  api = api.replace(":3001", ":3002");
}

export const API_URL = api;


export * from "./jobs"
export * from "./expenses"
export * from "./payments"
export * from "./billingOrders"
export * from "./lots"

// Actions
export const LOGIN_FAILURE = "LOGIN_FAILURE"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGOUT = "LOGOUT"

const loginSuccess = ( response: any ) => ( { type: LOGIN_SUCCESS, response } )
const loginFail = ( response: any ) => ( { type: LOGIN_FAILURE, response } )
export const logout = () => ( { type: LOGOUT } )

export const login = ( username: string, password: string ) => ( dispatch: any ) => {
  const headers = new Headers()
  headers.append( "Authorization", "Basic " + btoa( username + ":" + password ) )

  const body = new FormData()
  body.append( "query", JSON.stringify( {
    command: "login",
  } ) )

  return fetch( API_URL, {
    method: "POST",
    headers,
    body,
  } ).then(
    res => {
      res.json().then( json =>
        dispatch( ( res.status === 200 ) ? loginSuccess( json ) : loginFail( json ) )
      )
    }
  )
}

export const SUGGESTION_UPDATE = "SUGGESTION_UPDATE"

const suggestionUpdate = ( name: string, response: any ) => ( {
  type: SUGGESTION_UPDATE,
  name,
  response,
} )

export const getAllSuggestions = () => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getAllSuggestions" )
    .then( resObj => _.get( resObj, "result", {} ) )
    .then( suggestionMap => _.map(
      suggestionMap,
      ( suggestion, name ) => dispatch( suggestionUpdate( name, suggestion ) )
    ) )

export const GET_PROCEDURE = "GET_PROCEDURE"

export const getProc = ( response: any ) => ( {
  type: GET_PROCEDURE,
  response,
} )

export const getProcedureByContactId = ( id: number ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getDebtByDebtorId", { id } ).then( ( resObj ) => {
    if ( resObj ) {
      dispatch( getProc( resObj.result ) )
    }
  } )

export const SET_DEBT = "SET_DEBT"

export const getDebt = ( response: any ) => ( {
  type: SET_DEBT,
  response,
} )

export const getDebtById = ( id: number ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getDebt", { id } ).then( ( resObj ) => {
    if ( resObj ) {
      dispatch( getDebt( resObj.result ) )
    }
  } )

export const getDebtDebtors = ( token: string, id: number ) => apiTokenCommand( token, {
  command: "getDebtDebtors",
  args: { id },
} )


export const SET_PAYMENTAGREEMENT = "SET_PAYMENTAGREEMENT"

export const getPaymentById = ( response: any ) => ( {
  type: SET_PAYMENTAGREEMENT,
  response,
} )

export const getPaymentAgreementById = ( id: number ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getPaymentAgreementById", { id } ).then( ( resObj ) => {
    if ( resObj ) {
      dispatch( getPaymentById( resObj.result ) )
    }
  } )

export const SEARCH_UPDATE = "SEARCH_UPDATE"
export const SEARCH_INFLIGHT_UPDATE = "SEARCH_INFLIGHT_UPDATE"

export const searchInFlight = ( queryType: string, enable: boolean ) => ( {
  type: SEARCH_INFLIGHT_UPDATE,
  queryType,
  enable,
} )

export const searchUpdate = ( queryType: string, response: any ) => ( {
  type: SEARCH_UPDATE,
  queryType,
  response,
} )

const defaultSearchParams = {
  size: 20,
}
export const search = ( type: string, params: any, pagination: any = defaultSearchParams ) =>
  ( dispatch: any, getState: any ) => {
    const args = {
      type,
      params,
      pagination,
    }
    dispatch( searchInFlight( type, true ) )
    return apiCommand( dispatch, getState, "search", args ).then( ( resObj ) => {
      dispatch( searchInFlight( type, false ) )
      if ( resObj ) {
        dispatch( searchUpdate( type, {
          params,
          ...resObj.result,
        } ) )
      }
    } )
  }


export const searchNextPage = ( type: string ) => ( dispatch: any, getState: any ) => {
  const storeSearch = getState().search[ type ]

  if ( storeSearch === undefined ) {
    return null // TODO: Should we return a promise?
  }

  const pagination = storeSearch.pagination
  const offset = pagination.offset + pagination.size
  const newPagination = {
    offset,
    limit: Math.min( pagination.total - offset, pagination.size ),
  }
  return search( type, storeSearch.params, newPagination )( dispatch, getState )
}


export const SET_INTEREST_TYPES = "SET_INTEREST_TYPES"
export const UPDATE_INTEREST_TYPE = "UPDATE_INTEREST_TYPE"

const setInterestTypes = ( types: mixed[] ) => ( { type: SET_INTEREST_TYPES, types } )
const updateInterestTypeAction = ( interestType: mixed ) => ( { type: UPDATE_INTEREST_TYPE, interestType } )

export const getAllInterestTypes = () => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getAllInterestTypes" ).then( ( resObj ) => {
    if ( resObj ) {
      dispatch( setInterestTypes( resObj.result ) )
    }
  } )

export const updateInterestType = ( newInterestType ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "updateInterestType", newInterestType ).then( ( resObj ) => {
    if ( resObj ) {
      dispatch( updateInterestTypeAction( resObj.result ) )
    }
  } )



export const SYSTEM_USERS_SET = "SYSTEM_USERS_SET"
export const SYSTEM_USERS_ADD = "SYSTEM_USERS_ADD"
export const SYSTEM_USERS_UPDATE = "SYSTEM_USERS_UPDATE"
export const SYSTEM_USERS_REMOVE = "SYSTEM_USERS_REMOVE"

const setSystemUsers = ( users ) => ( { type: SYSTEM_USERS_SET, users } )
const addSystemUser = ( user ) => ( { type: SYSTEM_USERS_ADD, user } )
const updateSystemUser = ( user ) => ( { type: SYSTEM_USERS_UPDATE, user } )
const removeSystemUser = ( id ) => ( { type: SYSTEM_USERS_REMOVE, id } )

export const newUser = ( user ) => {

  if ( !user.config ) {
    user.config = DEFAULT_USER_CONFIG
  }

  const filteredUser = _.omit( user, [ "createdAt", "updatedAt" ] )

  return ( dispatch: any, getState: any ) =>
    apiCommand( dispatch, getState, "newUser", filteredUser ).then( resObj => {
      if ( resObj ) {
        dispatch( addSystemUser( resObj.result ) )
      }
    } )
}

export const getUsers = () => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getUsers" ).then( resObj => {
    if ( resObj ) {
      dispatch( setSystemUsers( resObj.result ) )
    }
  } )
export const updateUser = ( user ) => {
  const filteredUser = _.omit( user, [ "createdAt", "updatedAt" ] )

  return ( dispatch: any, getState: any ) =>
    apiCommand( dispatch, getState, "updateUser", filteredUser ).then( resObj => {
      if ( resObj ) {
        dispatch( updateSystemUser( resObj.result ) )
      }
    } )
}

export const removeUser = ( userId: number ) => {
  return ( dispatch: any, getState: any ) =>
    apiCommand( dispatch, getState, "removeUser", { id: userId } ).then( resObj => {
      if ( resObj ) {
        dispatch( removeSystemUser( userId ) )
      }
    } )
}

export const ADD_CONTACT = "ADD_CONTACT"

const addContact = ( response: any ) => ( {
  type: ADD_CONTACT,
  response,
} )

// TODO: Rename this to newContactHistory
export const newContact = ( contact: any ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "newContactHistory", contact ).then( resObj => {
    if ( resObj ) {
      dispatch( addContact( resObj.result ) )
    }
    return resObj
  } )

export const removeContactHistory = ( id: any ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "removeContactHistory", { id } )


const DEFAULT_USER_CONFIG = {
  name: true,
  nif: true,
  debtValue: true,
}
export const ADD_PAYMENTAGREEMENT = "ADD_PAYMENTAGREEMENT"

const addPaymentAgreement = ( response: any ) => ( {
  type: ADD_PAYMENTAGREEMENT,
  response,
} )

export const newPaymentAgreement = ( paymentAgreement: any ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "newPaymentAgreement", paymentAgreement ).then( resObj => {
    if ( resObj ) {
      dispatch( addPaymentAgreement( resObj.result ) )
    }
  } )

export const UPDATE_PAYMENT_AGREEMENT = "UPDATE_PAYMENT_AGREEMENT"

const updatePA = ( response: any ) => ( {
  type: UPDATE_PAYMENT_AGREEMENT,
  response,
} )

export const updatePaymentAgreement = ( paymentAgreement: any ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "updatePaymentAgreement", paymentAgreement ).then( resObj => {
    if ( resObj ) {
      dispatch( updatePA( resObj.result ) )
      dispatch( getPaymentById( resObj.result ) )
    }
  } )

export const SET_PAYMENTAGREEMENTS = "SET_PAYMENTAGREEMENTS"

const paymentAgreements = ( response: any ) => ( {
  type: SET_PAYMENTAGREEMENTS,
  response,
} )

export const getAllPaymentAgreements = () => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getAllPaymentAgreements" ).then( ( resObj ) => {
    if ( resObj ) {
      dispatch( paymentAgreements( resObj.result ) )
    }
  } )

export const USER_CONFIG_SET = "USER_CONFIG_SET"

export const setUserConfigAction = ( config: DEFAULT_USER_CONFIG ) => {
  const isConfigEmpty = _.every( config, field => !field )
  if ( !config || isConfigEmpty ) {
    config = DEFAULT_USER_CONFIG
  }

  return { type: USER_CONFIG_SET, config }
}

export const USER_SET = "USER_SET"

export const setUser = ( user: any ) => {
  const isConfigEmpty = _.every( user.config, field => !field )
  if ( !user.config || isConfigEmpty ) {
    user.config = DEFAULT_USER_CONFIG
  }

  return { type: USER_SET, user }
}

export const refreshUser = () => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getUser", { id: "self" } ).then( resObj => {
    if ( resObj ) {
      dispatch( setUser( resObj.result ) )
    }
  } )



export const setUserConfig = ( config: {} = DEFAULT_USER_CONFIG ) => ( dispatch: any ) =>
  dispatch( setUserConfigAction( config ) )

export const refreshUserConfig = () => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getUserConfig", { id: "self" } ).then( resObj => {
    if ( resObj ) {
      dispatch( setUserConfigAction( resObj.result ) )
    }
  } )

export const saveUserConfig = () => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "setUserConfig", {
    id: "self",
    config: getState().user.config,
  } ).then( done => {
    if ( done ) {
      toastr.success( "Configurações guardadas com successo" )
    }
  } )

export const SYSTEM_GROUPS_ADD = "SYSTEM_GROUPS_ADD"
const addSystemGroup = ( group ) => ( { type: SYSTEM_GROUPS_ADD, group } )

export const newGroup = ( groupInfo ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "newGroup", groupInfo ).then( resObj => {
    if ( resObj ) {
      dispatch( addSystemGroup( resObj.result ) )
    }
  } )

export const SYSTEM_GROUPS_SET = "SYSTEM_GROUPS_SET"
const setSystemGroups = ( groups ) => ( { type: SYSTEM_GROUPS_SET, groups } )

export const getGroups = () => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getGroups" ).then( resObj => {
    if ( resObj ) {
      dispatch( setSystemGroups( resObj.result ) )
    }
  } )

export const PROCEDURE_UPDATE = "PROCEDURE_UPDATE"

const emitProcedureUpdate = ( procedure: any ) => ( { type: PROCEDURE_UPDATE, procedure } )

export const procedureUpdate = ( procedure: any ) => ( dispatch: any ) =>
  dispatch ( emitProcedureUpdate( procedure ) )

export const getProcedure = ( id: number ) => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getProcedure", { id } ).then( ( resObj ) => {
    if ( resObj ) {
      dispatch( emitProcedureUpdate( resObj.result ) )
    }
  } )

export const UPDATE_IMPORTS = "UPDATE_IMPORTS"

const emitUpdateImports = ( imports: any ) => ( { type: UPDATE_IMPORTS, imports } )

export const importsUpdate = ( imports: any ) => ( dispatch: any ) =>
  dispatch ( emitUpdateImports( imports ) )


export const getImports = () => ( dispatch: any, getState: any ) =>
  apiCommand( dispatch, getState, "getImports" ).then( ( resObj ) => {
    if ( resObj ) {
      dispatch( importsUpdate( resObj.result ) )
    }
  } )

export const getLitigationById = ( token: string, id: number ) => apiTokenCommand( token, {
  command: "getLitigation",
  args: { id },
} )

export const getPreLitigationById = ( token: string, id: number ) => apiTokenCommand( token, {
  command: "getPreLitigation",
  args: { id },
} )

export const getExecutionById = ( token: string, id: number ) => apiTokenCommand( token, {
  command: "getExecution",
  args: { id },
} )

export const updateContactHistory = ( token: string, contactHistory: any ) => apiTokenCommand( token, {
  command: "updateContactHistory",
  args: { ...contactHistory },
} )

export const updateDebt = ( token: string, debt: any ) => apiTokenCommand( token, {
  command: "updateDebt",
  args: { ...debt },
} )

export const updateDebtorContact = ( token: string, debtor: any ) => apiTokenCommand( token, {
  command: "updateDebtor",
  args: {
    ...debtor,
    contact: _.omit( debtor.contact, [ "publicExecutions", "publicInsolvencies" ] ),
  },
} )

export const debtorSearch = ( token: string, name: string, nif: number ) => apiTokenCommand( token, {
  command: "search",
  args: {
    type: "debtorSearch",
    params: {
      name,
      nif,
    },
  },
} )


export const stats = ( token: string ) => apiTokenCommand( token, { command: "stats" } )


export const recoverPassword = ( email: string ) => apiTokenCommand( undefined, {
  command: "recoverPassword",
  args: { email },
} )

export const changePassword = ( password: string, recoverToken: string ) => apiTokenCommand( undefined, {
  command: "changePassword",
  args: { password, recoverToken },
} )

type Pagination = {
  limit?: number,
  offset?: number,
}

type Extra = {
  ids?: boolean,
}

export const debtSimpleSearch = ( token: string, term: string, pagination?: Pagination, extra?: Extra ) => apiTokenCommand( token, {
  command: "search",
  args: {
    type: "debtSimpleSearch",
    params: {
      term,
    },
    pagination,
    extra,
  },
} )

export const debtAdvancedSearch = (
  token: string,
  params: mixed,
  pagination?: Pagination,
  extra: any,
) => apiTokenCommand( token, {
  command: "search",
  args: {
    type: "debtAdvancedSearch",
    params,
    pagination,
    extra,
  },
} )

// CONTRACT FUNC
export const addContract = ( token: string, contract: any ) => apiTokenCommand( token, {
  command: "addContract",
  args: { ...contract },
} )

export const updateContractById = ( token: string, contract: any ) => apiTokenCommand( token, {
  command: "updateContract",
  args: { ...contract },
} )

export const removeContractById = ( token: string, id: any ) => apiTokenCommand( token, {
  command: "removeContract",
  args: { id },
} )

export const removePaymentAgreement = ( token: string, id: any ) => apiTokenCommand( token, {
  command: "removePaymentAgreement",
  args: { id },
} )

// INVOICE FUNC
export const addInvoice = ( token: string, invoice: any ) => apiTokenCommand( token, {
  command: "addInvoice",
  args: { ...invoice },
} )

export const updateInvoiceById = ( token: string, invoice: any ) => apiTokenCommand( token, {
  command: "updateInvoice",
  args: { ...invoice },
} )

export const sendPreLitigationNotification = ( token: string, id: any ) => apiTokenCommand( token, {
  command: "sendPreLitigationNotification",
  args: { id },
} )

export const updatePrelitigation = ( token: string, preLitigation: any ) => apiTokenCommand( token, {
  command: "updatePreLitigation",
  args: { ...preLitigation },
} )

export const updateLitigation = ( token: string, litigation: any ) => apiTokenCommand( token, {
  command: "updateLitigation",
  args: { ...litigation },
} )

export const updateExecution = ( token: string, execution: any ) => apiTokenCommand( token, {
  command: "updateExecution",
  args: { ...execution },
} )

export const removeInvoiceById = ( token: string, id: any ) => apiTokenCommand( token, {
  command: "removeInvoice",
  args: { id },
} )

export const addDebtor = ( token: string, debtor: any ) => apiTokenCommand( token, {
  command: "addDebtor",
  args: { ...debtor },
} )

export const removeDebtor = ( token: string, id: any ) => apiTokenCommand( token, {
  command: "removeDebtor",
  args: { ...id },
} )

export const getContactHistorybyDebtId = ( token: string, idDebt: any ) => apiTokenCommand( token, {
  command: "getContactHistoryByDebtId",
  args: { idDebt },
} )

// Logs
export const getLogs = ( token: string ) => apiTokenCommand( token, {
  command: "getLogs",
  args: {},
} )

export const bulkOperation = ( token: string, type: string, args: any ) => apiTokenCommand( token, {
  command: "bulkOperation",
  args: {
    type,
    args,
  },
} )

export const submitToCitius = ( token: string, ids: [number] ) =>
  bulkOperation( token, "citiusSubmission", { ids } )


export const generateReport = ( token: string, reportType: string, ids: any, filters: any ) => unparsedTokenCommand( token, {
  command: "bulkOperation",
  args: {
    type: reportType,
    ids,
    filters,
  },
} )





export const apiTokenCommand = ( ...a ) => unparsedTokenCommand( ...a ).then( result => result.json() )
export const unparsedTokenCommand = async ( token: string, query: {} | string, extraBody: any = {} ) => {
  const body = new FormData()
  body.append( "token", token )
  body.append( "query", typeof query === "string" ? query : JSON.stringify( query ) )
  _.forEach( extraBody, ( v, k ) => body.append( k, v ) )

  return fetch( API_URL, {
    method: "POST",
    body,
  } )
    .then( res => {
      if ( res.status < 200 || res.status >= 300 ) {
        return Promise.reject( res )
      }
      return res
    } )
}




// Generic Functions
export function apiCommand ( dispatch: any, getState: any, command: string, args: any, extraBody: any = {} ) {
  // TODO: Logout user if we dont have a token
  let token = getState().auth.token
  if ( !token ) {
    deleteToken( dispatch )
    return Promise.reject( null )
  }

  const body = new FormData()
  body.append( "token", token )
  body.append( "query", JSON.stringify( {
    command,
    args,
  } ) )

  _.forEach( extraBody, ( v, k ) => body.append( k, v ) )

  return fetch( API_URL, { method: "POST", body } )
    .then( res => {
      const contentType = res.headers.get( "Content-Type" )
      if ( contentType && !contentType.includes( "application/json" ) ) {
        return res
      }

      return res.json()
        .then( json => {
          const invalidToken = res.status === 401 && json.message === "Invalid token"
          if ( invalidToken ) {
            // Token has been invalidated
            deleteToken( dispatch )
          }
          if ( res.status !== 200 && !invalidToken ) {
            return Promise.reject( res )
          }
          return json
        } )
    } )
    // This is causing more trouble than its worth
    // .catch( e => {
    //   console.error( e )
    //   toastr.error(
    //     "Erro ao contactar o servidor",
    //     "Verifique o acesso a internet"
    //   )
    // } )
}

function deleteToken ( dispatch ) {
  toastr.error(
    "Erro",
    "Por favor volte a fazer login"
  )
  dispatch( loginFail( {
    response: {
      message: "InvalidToken",
      token: undefined,
    },
  } ) )
}



// WEBPACK FOOTER //
// ./src/actions/index.jsx